import React, { useReducer } from "react";
import { useCallback } from "react";
import PropTypes from "prop-types";
import { UploadContextProvider } from "./context";
import reducer from "./uploadsReducer";

const initialState = {};

export const UploadProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const getAllUploads = useCallback(() => {
    return Object.values(state).reduce((acc, value) => {
      return [...acc, value.uploads];
    }, []);
  }, [state]);

  const getAllUploaded = useCallback(() => {
    return Object.values(state).reduce((acc, value) => {
      return [...acc, value.uploaded];
    }, []);
  }, [state]);

  const getStateByContext = useCallback(
    (context) =>
      state[context] ?? {
        uploads: {},
        uploading: false,
        uploaded: [],
        error: {},
      },
    [state]
  );

  const getDispatch = useCallback((context) => {
    return (attrs) => dispatch({ context, ...attrs });
  }, []);

  return (
    <UploadContextProvider
      value={{
        getAllUploads,
        getAllUploaded,
        getStateByContext,
        getDispatch,
      }}
    >
      {children}
    </UploadContextProvider>
  );
};

UploadProvider.propTypes = {
  children: PropTypes.any,
};
